// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BcN6fxKiMTIXzO {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.CdzbH4AY09N5Lh {
  flex: 1 1 100%;
  max-width: 100%;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
.PX6YhEj17zsFe3 {
  flex: 2.5;
  max-width: 100%;
  margin: var(--ds-space-150, 12px) var(--ds-space-100, 8px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.M92r2U4d5PdbHZ {
  flex: 1;
  max-width: 100%;
  margin: var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-100, 8px);
}
.kzxFWTTIZHK0YZ {
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text-subtle, #44546f);
}
.nMRV8L03x9GMtS {
  font: var(--ds-font-body, 400 14px / 20px -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-display: swap;
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: var(--ds-space-150, 12px);
  margin-bottom: var(--ds-space-050, 4px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
  margin-bottom: var(--ds-space-050, 2px);
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}
.FBj2i_TEbJ7Vof {
  margin: var(--ds-space-100, 8px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var formGridSelectContainer = `BcN6fxKiMTIXzO`;
export var boardSelectContainer = `CdzbH4AY09N5Lh`;
export var listSelectContainer = `PX6YhEj17zsFe3`;
export var positionSelectContainer = `M92r2U4d5PdbHZ`;
export var enterpriseBoardMessage = `kzxFWTTIZHK0YZ`;
export var selectLabel = `nMRV8L03x9GMtS`;
export var button = `FBj2i_TEbJ7Vof`;
export default ___CSS_LOADER_EXPORT___;
